import {components} from 'metronic-extension';

/**
 * APIクライアントの基底クラス
 * 全てのAPIクライアントはこのクラスを継承する
 */
export default class BaseApi extends components.Api {
  /**
   * APIクライアントを初期化する
   * @param {string} path リクエスト用のベースURL
   */
  constructor(path) {
    super(path, null, {
      headers: {
        // サーバー側でAjaxリクエストかどうかを判定するためのヘッダー
        // Express.jsでは req.xhr でこのヘッダーの有無を確認できる
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
  }

  /**
   * APIエラーを処理する
   * @param {number} code HTTPステータスコード
   * @param {Error} error エラーオブジェクト
   * @return {void}
   */
  errorHook(code, error) {
    // エラー詳細をログ出力
    const url = error?.request?.responseURL;
    const message = error?.message || '不明なエラー';
    console.error(`APIエラー: コード ${code}, メッセージ: ${message}${url ? `, URL: ${url}` : ''}`);
  }
}
